var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let AmountInput = class AmountInput extends Vue {
    get internalValue() {
        if (this.value === null)
            return '';
        return this.value / 100;
    }
    set internalValue(value) {
        if (value === '')
            this.$emit('input', null);
        else
            this.$emit('input', Math.round(value * 100));
    }
};
__decorate([
    Prop({ type: Number })
], AmountInput.prototype, "value", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AmountInput.prototype, "required", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AmountInput.prototype, "disabled", void 0);
AmountInput = __decorate([
    Component
], AmountInput);
export default AmountInput;
